module.exports = __webpack_public_path__ + "static/img/about-map.de451a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/about-map.png
// module id = L6cn
// module chunks = 4